import { render, staticRenderFns } from "./registre-ge.html?vue&type=template&id=cb02022a&scoped=true&external"
import script from "./registre-ge.js?vue&type=script&lang=js&external"
export * from "./registre-ge.js?vue&type=script&lang=js&external"
import style0 from "./registre-ge.scss?vue&type=style&index=0&id=cb02022a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb02022a",
  null
  
)

export default component.exports